import React from 'react';

import TestIntroduction from '~/modules/Count/components/Introduction';
import Cards from '~/modules/Count/components/Cards';
import Answer from '~/modules/Count/components/Answer';
import Result from '~/modules/Count/components/Result';

import { DISPLAY_WINDOW, INITIAL_STATE, GAME_OPTIONS } from '~/constants/count_const';

class Count extends React.Component {
  state = INITIAL_STATE;

  onNameChangeHandler = event => {
    this.setState({ name: event.target.value });
  };

  onAgeChangeHandler = ageValue => {
    this.setState({ ageValue });
  };

  onAnswerChange = event => {
    if (/^\d+$/.test(event.target.value)) {
      this.setState({ answer: event.target.value });
    }
  }

  onGameStartClick = async () => {
    const { ageValue } = this.state;
    const currentTestArray = GAME_OPTIONS[ageValue];

    const {
      delayTime,
      numbers,
      signs,
      correctAnswer
    } = currentTestArray[Math.round(Math.random() * 10) % currentTestArray.length];

    this.setState({ stage: DISPLAY_WINDOW.GAME, correctAnswer });

    for (let i = 0; i < numbers.length; i++) {
      await new Promise((resolve) => {
        setTimeout(() => {
          this.setState({ number: numbers[i], sign: signs[i], fadeIn: true });
          resolve();
        }, 500);
      });

      await new Promise((resolve) => {
        setTimeout(() => {
          this.setState({ fadeIn: false, });
          resolve();
        }, 500 + delayTime);
      });
    }

    this.setState({ stage: DISPLAY_WINDOW.ANSWER, correctAnswer });
  };

  checkAnswer = () => {
    const {
      correctAnswer,
      answer
    } = this.state;
    this.setState({ stage: DISPLAY_WINDOW.RESULT, correctAnswer: Number(correctAnswer) === Number(answer) });
  };

  restartGame = () => {
    this.setState(INITIAL_STATE);
  }

  render() {
    const { INTRODUCTION, GAME, ANSWER, RESULT } = DISPLAY_WINDOW;
    const { stage, number, sign, fadeIn, correctAnswer, ageValue, name, answer } = this.state;

    return (
      <div className="count">
        {(() => {
          switch(stage) {
            case INTRODUCTION:
              return (
                <TestIntroduction
                  onAgeChangeHandler={this.onAgeChangeHandler}
                  onNameChangeHandler={this.onNameChangeHandler}
                  onGameStartClick={this.onGameStartClick}
                  ageValue={ageValue}
                />
              );
            case GAME:
              return (
                <Cards
                  number={number}
                  sign={sign}
                  fadeIn={fadeIn}
                />
              );
            case ANSWER:
              return (
                <Answer
                  onAnswerButtonClick={this.checkAnswer}
                  onAnswerChange={this.onAnswerChange}
                  answer={answer}
                />
              );
            case RESULT:
              return (
                <Result
                  name={name}
                  correctAnswer={correctAnswer}
                  ageCategory={ageValue}
                  restartGameClick={this.restartGame}
                />
              );
            default:
              return;
          }
        })()}
      </div>
    )
  };
}

export default Count;
